import axios from '@axios'

import qs from 'qs'

const prefixPath = '/api/market/promote'
export default {

  saveOrUpdate(data) {
    return axios.post(`${prefixPath}/saveOrUpdate`, data)
  },

  getPages(data) {
    return axios.post(`${prefixPath}/getPages`, data)
  },

  delete(id) {
    return axios.post(`${prefixPath}/delete`, qs.stringify({
      id,
    }))
  },

  getDetail(id) {
    return axios.get(`${prefixPath}/getDetail`, {
      params: {
        id,
      },
    })
  },

  listAll() {
    return axios.get(`${prefixPath}/listAll`)
  },

}
